import { useNavigate } from 'react-router-dom';
import type { SalonFlowPlanKey } from './salonflowPlans';
import { SALONFLOW_PLAN_LABEL } from './salonflowPlans';
import { Lock } from 'lucide-react';

type Props = {
  minimumPlan?: SalonFlowPlanKey | null;
  sectionTitle?: string;
};

export default function LockedFeaturePage({ minimumPlan, sectionTitle }: Props) {
  const navigate = useNavigate();
  const planLabel =
    minimumPlan != null ? SALONFLOW_PLAN_LABEL[minimumPlan] : 'plano mais completo';

  return (
    <div className="flex min-h-[50vh] items-center justify-center px-4 pb-16 pt-8">
      <div className="sf-gradient-card card w-full max-w-lg rounded-[1.75rem] border border-white/5 bg-base-100/80 p-8 shadow-xl backdrop-blur">
        <div className="mb-6 flex justify-center">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-base-200/80 text-xl text-secondary">
            <Lock aria-hidden="true" />
          </span>
        </div>
        <h2 className="mb-3 text-center text-xl font-semibold tracking-tight text-base-content">
          Recurso indisponível no seu plano
        </h2>
        {!!sectionTitle && (
          <p className="mb-2 text-center text-sm opacity-75">{sectionTitle}</p>
        )}
        <p className="mb-8 text-center text-sm leading-relaxed opacity-85">
          Faça upgrade para o plano {planLabel}
          {' '}para usar este recurso.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <button type="button" className="btn rounded-xl px-6" onClick={() => navigate(-1)}>
            Voltar
          </button>
          <button type="button" className="btn btn-primary rounded-xl px-6" onClick={() => navigate('/meu-plano')}>
            Ver planos e fazer upgrade
          </button>
        </div>
      </div>
    </div>
  );
}
